import React from 'react';
import Link from 'src/components/Link';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';
import questionMark from './question_mark.svg';

type Props = {
  className?: string;
}

const HelpLink: React.FC<Props> = ({ className}) => {
  return (
    <Link to={routes.help} className={className} target="_blank">
      <img src={questionMark} alt="" className={styles['helpImg']}/>Нужна помощь?
    </Link>
  );
};

export default HelpLink;
